module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-16.b52c4acf.png";